
window.PB_SHOPIFY = {
  
  hotTubs: {
    '630L-115': { variantId: 67581609607342, handle: 'equinox-630l-115v' },   
    '630L-230': { variantId: 67581609640110, handle: 'equinox-630l-230v' },   
    '743L-230': { variantId: 67581609672878, handle: 'equinox-743l-230v' },   
    '744B-230': { variantId: 67581609705646, handle: 'equinox-744b-230v' }    
  },

  
  cover: { variantId: 67581609738414, handle: 'custom-spa-cover' },

  
  cartDrawerSelector: null,

  
  enquiryAnchor: '#hot-tub-contact'
};
